import React from "react";
import { Link } from "react-router-dom";
import FeatureList from "./FeatureList";
import PlanPrice from "./PlanPrice";
import { planCardData } from "../../utils/data";

/*
    STATIC DATA — the one-time database purchase, in the slot the Enterprise
    API block used to occupy.

    It is not a fourth pricing column: there is nothing to subscribe to, the
    price is three orders of magnitude away from the monthly tiers, and the
    next step is a conversation rather than a checkout. So it gets a wide
    panel under the grid, sharing the card vocabulary without pretending to be
    comparable.

    The content is the `static-data` entry from the same catalogue as the
    tiers — it is marked `listed: false`, which is what keeps it out of the
    grid above.

    "Get in Touch" is an in-app <Link> to /api/support rather than the
    absolute https://golfbert.com/api/support from the brief. Same page, but a
    router link keeps it a client-side navigation instead of a full reload,
    and it does not break on dev or a local build the way a hardcoded
    production host would.
*/
const StaticDataPanel = () => {
  const plan = planCardData.find((entry) => entry.id === "static-data");
  if (!plan) return null;

  return (
    <section className="static-data" aria-labelledby="static-data-heading">
      <div className="static-data__panel">
        <div>
          <h2 id="static-data-heading" className="static-data__heading">
            {plan.nickname}
          </h2>

          {plan.pill && (
            <span className="plan-tier__pill plan-tier__pill--inline">
              {plan.pill}
            </span>
          )}
          <p className="static-data__description">{plan.subTitle}</p>

          <PlanPrice
            amount={plan.unit_amount}
            interval={plan.recurring?.interval}
          />

          <p className="static-data__meta">{plan.meta}</p>

          <Link to={plan.path} className="plan-tier__cta">
            {plan.btnText}
          </Link>
        </div>

        <div className="static-data__aside">
          <div className="plan-tier__includes">Includes:</div>
          <FeatureList features={plan.features} />
        </div>
      </div>
    </section>
  );
};

export default StaticDataPanel;
